export const commonValues = {
  iconsConfig: {
    iconsPath: "assets/images/map-icons/",
    notFound: {
      code: "0",
      name: "Icon non trouvé",
      fileName: "not-found.svg",
      fileNameSelected: "not-found_sele.svg",
      fileNameStatus: "not-found_stat.svg",
      fileNameStd: "not-found_std.svg",
    },
    icons: [
      {
        code: "ANI-MOR",
        name: "Animal mort",
        fileName: "ani-mor.svg",
        fileNameSelected: "ani-mor_sele.svg",
        fileNameStatus: "ani-mor_stat.svg",
        fileNameStd: "ani-mor_std.svg",
      },
      {
        code: "ARB-TBE",
        name: "Arbre tombé",
        fileName: "arb-tbe.svg",
        fileNameSelected: "arb-tbe_sele.svg",
        fileNameStatus: "arb-tbe_stat.svg",
        fileNameStd: "arb-tbe_std.svg",
      },
      {
        code: "ARC-BRC",
        name: "Branche tombée",
        fileName: "arc-brc.svg",
        fileNameSelected: "arc-brc_sele.svg",
        fileNameStatus: "arc-brc_stat.svg",
        fileNameStd: "arc-brc_std.svg",
      },
      {
        code: "BAL-MEC",
        name: "Balai mécanique",
        fileName: "bal-mec.svg",
        fileNameSelected: "bal-mec_sele.svg",
        fileNameStatus: "bal-mec_stat.svg",
        fileNameStd: "bal-mec_std.svg",
      },
      {
        code: "CHA-GLI",
        name: "Chaussée glissante",
        fileName: "cha-gli.svg",
        fileNameSelected: "cha-gli_sele.svg",
        fileNameStatus: "cha-gli_stat.svg",
        fileNameStd: "cha-gli_std.svg",
      },
      {
        code: "CHA-PRC",
        name: "Chalet de parc",
        fileName: "cha-prc.svg",
        fileNameSelected: "cha-prc_sele.svg",
        fileNameStatus: "cha-prc_stat.svg",
        fileNameStd: "cha-prc_std.svg",
      },
      {
        code: "COL-ALI",
        name: "Collecte de résidus alimentaires",
        fileName: "col-ali.svg",
        fileNameSelected: "col-ali_sele.svg",
        fileNameStatus: "col-ali_stat.svg",
        fileNameStd: "col-ali_std.svg",
      },
      {
        code: "COL-BRA",
        name: "Collecte de branches d'arbre - Agrile du frêne",
        fileName: "col-bra.svg",
        fileNameSelected: "col-bra_sele.svg",
        fileNameStatus: "col-bra_stat.svg",
        fileNameStd: "col-bra_std.svg",
      },
      {
        code: "COL-DEC",
        name: "Collecte de déchets",
        fileName: "col-dec.svg",
        fileNameSelected: "col-dec_sele.svg",
        fileNameStatus: "col-dec_stat.svg",
        fileNameStd: "col-dec_std.svg",
      },
      {
        code: "COL-ECR",
        name: "Collecte d'écran (ordinateur et téléviseur)",
        fileName: "col-ecr.svg",
        fileNameSelected: "col-ecr_sele.svg",
        fileNameStatus: "col-ecr_stat.svg",
        fileNameStd: "col-ecr_std.svg",
      },
      {
        code: "COL-ENC",
        name: "Collecte des encombrants",
        fileName: "col-enc.svg",
        fileNameSelected: "col-enc_sele.svg",
        fileNameStatus: "col-enc_stat.svg",
        fileNameStd: "col-enc_std.svg",
      },
      {
        code: "COL-ORG",
        name: "Collecte des matières organiques",
        fileName: "col-org.svg",
        fileNameSelected: "col-org_sele.svg",
        fileNameStatus: "col-org_stat.svg",
        fileNameStd: "col-org_std.svg",
      },
      {
        code: "COL-REC",
        name: "Collecte des matières recyclables",
        fileName: "col-rec.svg",
        fileNameSelected: "col-rec_sele.svg",
        fileNameStatus: "col-rec_stat.svg",
        fileNameStd: "col-rec_std.svg",
      },
      {
        code: "DEB-PUB",
        name: "Débris sur la voie publique",
        fileName: "deb-pub.svg",
        fileNameSelected: "deb-pub_sele.svg",
        fileNameStatus: "deb-pub_stat.svg",
        fileNameStd: "deb-pub_std.svg",
      },
      {
        code: "DEP-DEC",
        name: "Dépôt illégal - Déchets",
        fileName: "dep-dec.svg",
        fileNameSelected: "dep-dec_sele.svg",
        fileNameStatus: "dep-dec_stat.svg",
        fileNameStd: "dep-dec_std.svg",
      },
      {
        code: "DEP-NEI",
        name: "Dépôt illégal - Neige",
        fileName: "dep-nei.svg",
        fileNameSelected: "dep-nei_sele.svg",
        fileNameStatus: "dep-nei_stat.svg",
        fileNameStd: "dep-nei_std.svg",
      },
      {
        code: "ECL-EXI",
        name: "Éclairage existant - Entretien",
        fileName: "ecl-exi.svg",
        fileNameSelected: "ecl-exi_sele.svg",
        fileNameStatus: "ecl-exi_stat.svg",
        fileNameStd: "ecl-exi_std.svg",
      },
      {
        code: "FEU-CEN",
        name: "Feux de circulation - Entretien",
        fileName: "feu-cen.svg",
        fileNameSelected: "feu-cen_sele.svg",
        fileNameStatus: "feu-cen_stat.svg",
        fileNameStd: "feu-cen_std.svg",
      },
      {
        code: "FEU-CNV",
        name: "Feux de circulation - Nouvelle installation",
        fileName: "feu-cnv.svg",
        fileNameSelected: "feu-cnv_sele.svg",
        fileNameStatus: "feu-cnv_stat.svg",
        fileNameStd: "feu-cnv_std.svg",
      },
      {
        code: "GRA-DOM",
        name: "Graffitis - Domaine public",
        fileName: "gra-dom.svg",
        fileNameSelected: "gra-dom_sele.svg",
        fileNameStatus: "gra-dom_stat.svg",
        fileNameStd: "gra-dom_std.svg",
      },
      {
        code: "GRA-HAI",
        name: "Graffitis haineux",
        fileName: "gra-hai.svg",
        fileNameSelected: "gra-hai_sele.svg",
        fileNameStatus: "gra-hai_stat.svg",
        fileNameStd: "gra-hai_std.svg",
      },
      {
        code: "MOB-PAR",
        name: "Mobilier de parc",
        fileName: "mob-par.svg",
        fileNameSelected: "mob-par_sele.svg",
        fileNameStatus: "mob-par_stat.svg",
        fileNameStd: "mob-par_std.svg",
      },
      {
        code: "MOB-URB",
        name: "Mobilier urbain",
        fileName: "mob-urb.svg",
        fileNameSelected: "mob-urb_sele.svg",
        fileNameStatus: "mob-urb_stat.svg",
        fileNameStd: "mob-urb_std.svg",
      },
      {
        code: "NET-DOM",
        name: "Nettoyage du domaine public",
        fileName: "net-dom.svg",
        fileNameSelected: "net-dom_sele.svg",
        fileNameStatus: "net-dom_stat.svg",
        fileNameStd: "net-dom_std.svg",
      },
      {
        code: "NID-POU",
        name: "Nid-de-poule",
        fileName: "nid-pou.svg",
        fileNameSelected: "nid-pou_sele.svg",
        fileNameStatus: "nid-pou_stat.svg",
        fileNameStd: "nid-pou_std.svg",
      },
      {
        code: "NOT-FOUND",
        name: "Non-trouvé",
        fileName: "not-found.svg",
        fileNameSelected: "not-found_sele.svg",
        fileNameStatus: "not-found_stat.svg",
        fileNameStd: "not-found_std.svg",
      },
      {
        code: "OPE-NEI",
        name: "Opération déneigement",
        fileName: "ope-nei.svg",
        fileNameSelected: "ope-nei_sele.svg",
        fileNameStatus: "ope-nei_stat.svg",
        fileNameStd: "ope-nei_std.svg",
      },
      {
        code: "PAN-RUE",
        name: "Panier de rue",
        fileName: "pan-rue.svg",
        fileNameSelected: "pan-rue_sele.svg",
        fileNameStatus: "pan-rue_stat.svg",
        fileNameStd: "pan-rue_std.svg",
      },
      {
        code: "PAN-PRC",
        name: "Panier de parc",
        fileName: "pan-prc.svg",
        fileNameSelected: "pan-prc_sele.svg",
        fileNameStatus: "pan-prc_stat.svg",
        fileNameStd: "pan-prc_std.svg",
      },
      {
        code: "PAR-PRO",
        name: "Parc - Propreté",
        fileName: "par-pro.svg",
        fileNameSelected: "par-pro_sele.svg",
        fileNameStatus: "par-pro_stat.svg",
        fileNameStd: "par-pro_std.svg",
      },
      {
        code: "PLA-ARB",
        name: "Plantation d'arbre",
        fileName: "pla-arb.svg",
        fileNameSelected: "pla-arb_sele.svg",
        fileNameStatus: "pla-arb_stat.svg",
        fileNameStd: "pla-arb_std.svg",
      },
      {
        code: "PUI-1RE",
        name: "Puisard - Première intervention",
        fileName: "pui-1re.svg",
        fileNameSelected: "pui-1re_sele.svg",
        fileNameStatus: "pui-1re_stat.svg",
        fileNameStd: "pui-1re_std.svg",
      },
      {
        code: "SIG-NEI",
        name: "Signalisation - Neige",
        fileName: "sig-nei.svg",
        fileNameSelected: "sig-nei_sele.svg",
        fileNameStatus: "sig-nei_stat.svg",
        fileNameStd: "sig-nei_std.svg",
      },
      {
        code: "ARB-DGR",
        name: "Danger potentiel - Arbre",
        fileName: "arb-dgr.svg",
        fileNameSelected: "arb-dgr_sele.svg",
        fileNameStatus: "arb-dgr_stat.svg",
        fileNameStd: "arb-dgr_std.svg",
      },
      {
        code: "ABB-ARB",
        name: "Abattage d'arbre",
        fileName: "abb-arb.svg",
        fileNameSelected: "abb-arb_sele.svg",
        fileNameStatus: "abb-arb_stat.svg",
        fileNameStd: "abb-arb_std.svg",
      },
      {
        code: "AME-PAR",
        name: "Aménagement de parc",
        fileName: "ame-par.svg",
        fileNameSelected: "ame-par_sele.svg",
        fileNameStatus: "ame-par_stat.svg",
        fileNameStd: "ame-par_std.svg",
      },
      {
        code: "ARB-DIV",
        name: "Arbre - Divers",
        fileName: "arb-div.svg",
        fileNameSelected: "arb-div_sele.svg",
        fileNameStatus: "arb-div_stat.svg",
        fileNameStd: "arb-div_std.svg",
      },
      {
        code: "DOM-ARB",
        name: "Dommage - Racines d'arbres",
        fileName: "dom-arb.svg",
        fileNameSelected: "dom-arb_sele.svg",
        fileNameStatus: "dom-arb_stat.svg",
        fileNameStd: "dom-arb_std.svg",
      },
      {
        code: "ELA-ARB",
        name: "Élagage",
        fileName: "ela-arb.svg",
        fileNameSelected: "ela-arb_sele.svg",
        fileNameStatus: "ela-arb_stat.svg",
        fileNameStd: "ela-arb_std.svg",
      },
      {
        code: "ESS-ARB",
        name: "Essouchement",
        fileName: "ess-arb.svg",
        fileNameSelected: "ess-arb_sele.svg",
        fileNameStatus: "ess-arb_stat.svg",
        fileNameStd: "ess-arb_std.svg",
      },
      {
        code: "EXT-INS",
        name: "Extermination à l'extérieur - Insectes",
        fileName: "ext-ins.svg",
        fileNameSelected: "ext-ins_sele.svg",
        fileNameStatus: "ext-ins_stat.svg",
        fileNameStd: "ext-ins_std.svg",
      },
      {
        code: "GAZ-PUB",
        name: "Gazon ou mauvaises herbes - Domaine public",
        fileName: "gaz-pub.svg",
        fileNameSelected: "gaz-pub_sele.svg",
        fileNameStatus: "gaz-pub_stat.svg",
        fileNameStd: "gaz-pub_std.svg",
      },
      {
        code: "GAZ-REP",
        name: "Gazon - Réparation",
        fileName: "gaz-rep.svg",
        fileNameSelected: "gaz-rep_sele.svg",
        fileNameStatus: "gaz-rep_stat.svg",
        fileNameStd: "gaz-rep_std.svg",
      },
      {
        code: "HOR-DIV",
        name: "Horticulture - Divers",
        fileName: "hor-div.svg",
        fileNameSelected: "hor-div_sele.svg",
        fileNameStatus: "hor-div_stat.svg",
        fileNameStd: "hor-div_std.svg",
      },
      {
        code: "HOR-ENT",
        name: "Horticulture - Entretien",
        fileName: "hor-ent.svg",
        fileNameSelected: "hor-ent_sele.svg",
        fileNameStatus: "hor-ent_stat.svg",
        fileNameStd: "hor-ent_std.svg",
      },
      {
        code: "MAL-ARB",
        name: "Maladie ou insectes - Arbre",
        fileName: "mal-arb.svg",
        fileNameSelected: "mal-arb_sele.svg",
        fileNameStatus: "mal-arb_stat.svg",
        fileNameStd: "mal-arb_std.svg",
      },
      {
        code: "PAR-DIV",
        name: "Parc - Divers",
        fileName: "par-div.svg",
        fileNameSelected: "par-div_sele.svg",
        fileNameStatus: "par-div_stat.svg",
        fileNameStd: "par-div_std.svg",
      },
      {
        code: "TER-INS",
        name: "Terrain insalubre - Domaine privé",
        fileName: "ter-ins.svg",
        fileNameSelected: "ter-ins_sele.svg",
        fileNameStatus: "ter-ins_stat.svg",
        fileNameStd: "ter-ins_std.svg",
      },
      {
        code: "TRO-GLI",
        name: "Trottoir glissant",
        fileName: "tro-gli.svg",
        fileNameSelected: "tro-gli_sele.svg",
        fileNameStatus: "tro-gli_stat.svg",
        fileNameStd: "tro-gli_std.svg",
      },
      {
        code: "VAN-ARB",
        name: "Vandalisme ou accident - Arbre",
        fileName: "van-arb.svg",
        fileNameSelected: "van-arb_sele.svg",
        fileNameStatus: "van-arb_stat.svg",
        fileNameStd: "van-arb_std.svg",
      },
      {
        code: "DDS",
        name: "DDS",
        fileName: "srq-sta.svg",
        fileNameSelected: "srq-sta_sele.svg",
        fileNameStatus: "srq-sta_stat.svg",
        fileNameStd: "srq-sta_std.svg",
      },
    ],
  },
  iconsConfigSR: {
    icon: {
      code: "DDS",
      name: "DDS",
      fileName: "srq-sta.svg",
      fileNameSelected: "srq-sta_sele.svg",
      fileNameStatus: "srq-sta_stat.svg",
      fileNameStd: "srq-sta_std.svg",
    },
  },
};
